class ProgressPlayer {
    constructor(element) {
        this.element = element;
        this.video = this.element.querySelector('.video-container__video');
        this.playPauseBtn = this.element.querySelector('.video-container__btn');
        this.isPlaying = false;

        this.handleVideoEnd = this.handleVideoEnd.bind(this);
        this.showButton = this.showButton.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handlePlay = this.handlePlay.bind(this);
        this.handlePause = this.handlePause.bind(this);
        this.togglePlay = this.togglePlay.bind(this);
        this.checkActiveState = this.checkActiveState.bind(this);

        this.init();
    }

    init() {
        this.bindEvents();
        this.updateButtonState();
        this.startObserver();
    }

    bindEvents() {
        this.playPauseBtn.addEventListener('click', this.togglePlay);
        this.video.addEventListener('ended', this.handleVideoEnd);
        this.video.addEventListener('mouseenter', this.showButton);
        this.video.addEventListener('mouseleave', this.handleMouseLeave);
        this.video.addEventListener('play', this.handlePlay);
        this.video.addEventListener('pause', this.handlePause);
    }

    /**
     * Запускает наблюдение за изменением класса is-active
     */
    startObserver() {
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    this.checkActiveState();
                }
            });
        });

        this.observer.observe(this.element.parentElement, {
            attributes     : true,
            attributeFilter: ['class']
        });

        this.checkActiveState();
    }

    /**
     * Проверяет наличие класса is-active и останавливает видео если его нет
     */
    checkActiveState() {
        const isActive = this.element.classList.contains('is-active');

        if (!isActive && this.isPlaying) {
            this.pause();
        }
    }

    togglePlay() {
        if (this.video.paused) {
            this.video.play();
        } else {
            this.video.pause();
        }
    }

    handlePlay() {
        this.isPlaying = true;
        this.playPauseBtn.innerHTML = '❚❚';

        setTimeout(() => {
            if (this.isPlaying) {
                this.hideButton();
            }
        }, 1000);
    }

    handlePause() {
        this.isPlaying = false;
        this.playPauseBtn.innerHTML = '▶';
        this.showButton();
    }

    handleVideoEnd() {
        this.isPlaying = false;
        this.playPauseBtn.innerHTML = '⟳';
        this.showButton();
    }

    handleMouseLeave() {
        if (this.isPlaying && !this.video.ended) {
            setTimeout(() => {
                if (this.isPlaying) {
                    this.hideButton();
                }
            }, 500);
        }
    }

    showButton() {
        this.playPauseBtn.classList.remove('hidden');
    }

    hideButton() {
        this.playPauseBtn.classList.add('hidden');
    }

    updateButtonState() {
        if (this.video.ended) {
            this.playPauseBtn.innerHTML = '⟳';
        } else if (this.video.paused) {
            this.playPauseBtn.innerHTML = '▶';
        } else {
            this.playPauseBtn.innerHTML = '❚❚';
        }
    }

    play() {
        if (this.element.classList.contains('is-active')) {
            this.video.play();
        }
    }

    pause() {
        this.video.pause();
    }
}

export default ProgressPlayer;
